<div class="container">
  <div class="row back-navigation-btn">
    <app-navigate-back-btn (buttonClicked)="navigateToOrderOverViewPage()"></app-navigate-back-btn>
  </div>
  <stepper-bar [inputSteps]="extrasSteps" [currentStep]="1"></stepper-bar>

  <p class="create-extras-page-title">{{ 'EXTRAS_PAGE.TITLE' | translate }}</p>
  <div class="row">
    <div class="col">
      <app-baggage-accordion
        [extrasInfo]="extrasInfoData"
        [culture]="culture"
        (baggageSelectionChanged)="checkBaggageSelection($event)"
        [expandExtras]="expandExtras"
      >
      </app-baggage-accordion>
    </div>
  </div>

  <div class="row mt-2" *ngIf="checkLoungeAvailability()">
    <div class="col">
      <app-lounge-accordion
        [extrasInfo]="extrasInfoData"
        [culture]="culture"
        (loungeSelectionChanged)="checkLoungeSelection($event)"
        [expandExtras]="expandExtras"
      >
      </app-lounge-accordion>
    </div>
  </div>

  <div class="row mt-2" *ngIf="true">
    <div class="col">
      <app-airport-assistance-accordion
        [extrasInfo]="extrasInfoData"
        [culture]="culture"
        (assistanceSelectionChanged)="checkAirportAssistanceSelection($event)"
        [expandExtras]="expandExtras"
      >
      </app-airport-assistance-accordion>
    </div>
  </div>

  <div class="row py-3 navigation-buttons-container">
    <div class="col text-left back-navigation-btn">
      <app-navigate-back-btn (buttonClicked)="navigateToOrderOverViewPage()"></app-navigate-back-btn>
    </div>
    <div class="col text-right">
      <app-navigate-next-btn
        [handleOnClick]="true"
        [buttonClass]="isNextButtonDisabled ? 'disabled-button' : ''"
        (click)="navigateToOverviewPage()"
        class="float-right"
      ></app-navigate-next-btn>
    </div>
  </div>
</div>
